var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"canvasBox",style:(_vm.runFireworks ? ("height: " + _vm.canvasBoxHeight + "; width: " + _vm.canvasBoxWidth + ";") : "display: none")},[_c('canvas',{attrs:{"id":"canvas"}})])}
var staticRenderFns = []

export { render, staticRenderFns }